const env = process.env
export const getEnvVar = (key: string, initial = ''): string => env[key] || initial
